// extracted by mini-css-extract-plugin
export default {"nextButton":"NextButton_nextButton__3gTsc","nextButtonMoney":"NextButton_nextButtonMoney__yuLlf"};